import { createContext, useContext } from 'react';

export const ExecFilterContext = createContext(null);

export const useExecFilters = () => useContext(ExecFilterContext);

